import Vue from 'vue'
export default {
  registerStatusStepInitial: 'initial',
  registerStatusStepEmailVerification: 'email_verification',
  registerStatusPublish: 'publish',
  displayName(firstname, lastname, email, phone, id) {
    if (firstname !== '' && lastname !== '') {
      return firstname + ' ' + lastname
    } else {
      if (email !== '') {
        return email
      } else {
        if (phone !== '') {
          return phone
        }
      }
    }
    return id
  },
  displayPhone(phone, mobile) {
    if (phone !== '') {
      return phone
    }
    return mobile
  },
  displayAvatar(avatar, defaultAvatar) {
    if (avatar !== '' && avatar != null && avatar !== undefined) {
      return avatar
    }
    if (defaultAvatar !== undefined && defaultAvatar !== 'default') {
      return defaultAvatar
    }
    if (defaultAvatar === 'default') {
      return Mantle.Config.api.url + Mantle.Config.defaultAvatarUrl
    }
    return false
  }
}
